
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counselling/[[...search]]",
      function () {
        return require("private-next-pages/counselling/[[...search]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/counselling/[[...search]]"])
      });
    }
  